var map = {
  "./getty/ai_generator.svg": "8526",
  "./getty/arrow_down.svg": "73028",
  "./getty/arrow_previous.svg": "19351",
  "./getty/arrow_right.svg": "36390",
  "./getty/boards.svg": "16153",
  "./getty/camera.svg": "42483",
  "./getty/cart.svg": "64400",
  "./getty/checkmark.svg": "12113",
  "./getty/close.svg": "28754",
  "./getty/close_large.svg": "34658",
  "./getty/close_small.svg": "28518",
  "./getty/confirmed_checkmark.svg": "46879",
  "./getty/exclamation.svg": "81505",
  "./getty/facebook.svg": "95354",
  "./getty/hamburger.svg": "66679",
  "./getty/instagram.svg": "65326",
  "./getty/logos/g_logo.svg": "54662",
  "./getty/logos/getty_images.svg": "58015",
  "./getty/logos/getty_images_no_trademark.svg": "67927",
  "./getty/minus.svg": "68706",
  "./getty/phone.svg": "44102",
  "./getty/play.svg": "17076",
  "./getty/plus.svg": "70410",
  "./getty/recent_search.svg": "45870",
  "./getty/search.svg": "40478",
  "./getty/shared_boards.svg": "74947",
  "./getty/tooltip.svg": "8651",
  "./getty/twitter.svg": "28583",
  "./getty/user.svg": "88103",
  "./getty/video_clip.svg": "44364",
  "./istock/checkmark.svg": "92533",
  "./istock/tooltip.svg": "46567",
  "./istock/x_icon.svg": "1114",
  "./shared/close.svg": "6576"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 60965;
